import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.config.devtools = true;
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        // Product data
        mainProducts: [],
        addonProducts: [],
        cardProducts: [],

        // Selected products
        selectedMainProduct: null,
        selectedAddonProducts: [],
        selectedCardProduct: null,
        selectedIndividualAddons: [],
        savedCardProduct: null,

        // Box configuration
        maxCapacity: 135,
        boxQty: 1,
        productLimit: 10,
        boxName: "",
        defaulBoxName: "Box 1",
        cartNames: [],

        // Filtering and sorting
        occasions: [],
        categories: {},
        selectedOccasion: [],
        selectedCategories: ["View All"],
        selectedSort: "1",
        selectedFilters: [],
        rangePrice: { min: 0, max: 999 },

        // Card configuration
        selectedCardsOccasions: ["View All"],
        cardHasMessage: false,
        showCardAlert: false,

        // Mobile-specific filters (consider consolidating with desktop filters)
        selectedSortMobile: "1",
        selectedFiltersMobile: [],
        rangePriceMobile: { min: 0, max: 999 },
        selectedOccasionMobile: [],
        selectedCategoriesMobile: ["View All"],
        selectedCardsOccasionsMobile: ["View All"],

        // Cart and utility
        cartQty: 0,
        savedKey: null,
        isPage: true,
        multishipCallout: true,
        feeProduct: null,
        customData: [],

        //others
        isLoading: false
    },
    getters,
    mutations,
    actions
});

export default store;
